import { useEffect, useRef } from 'react';
import { useAuth } from 'Utils/Hooks/useAuth';
import authHelper from 'Utils/Helper/AuthHelpers';
import { PRIMARY_BASE_URL } from 'ui/lib/servers';

/**
 * Signs out: revokes the login token on the server (best effort), clears
 * local session data and reloads to the sign-in page.
 */
export default function Logout() {
  const { logout } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const token = authHelper.getToken();
    const finish = () => {
      logout();
      window.location.replace('/auth/login');
    };
    if (!token) return finish();
    const timer = setTimeout(finish, 2500);
    fetch(`${PRIMARY_BASE_URL}/auth/logout`, {
      method: 'POST',
      headers: { Accept: 'application/json', Authorization: `Bearer ${token}` },
    })
      .catch(() => {})
      .finally(() => {
        clearTimeout(timer);
        finish();
      });
  }, [logout]);

  return null;
}
